<template>
  <base-draggable-modal
      :name="modal_name"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.display.xsOnly"
      :ref="modal_name">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-text-field
                class="reg-normal text-primary"
                base-color="border-tertiary"
                bg-color="secondary"
                v-model="search"
                v-debounce:800ms.lock="launchSearch"
                @click:clear="clearSearch"
                :label="$store.getters.translate('search')"
                single-line
                hide-details
                flat
                clearable
                prepend-inner-icon="mdi-magnify"/>
            <Draggable
                ref="tree"
                class="mtl-tree ma-5"
                :defaultOpen="false"
                v-model="assets"
                :disableDrag="true"
                :disableDrop="true"
                indent="20"
                treeLine>
              <template #default="{ node, stat }">
                  <OpenIcon v-if="stat.children && stat.children.length" :open="stat.open" @click.native="stat.open = !stat.open"/>
                  <div v-else style="margin-left: 24px;"/>
                  <v-checkbox color="success" density="compact" v-model="selected_assets" :key="node.id" :value="node.id"/>
                  <span v-if="node && !node.children" class="sm-normal text-primary ma-3" style="cursor: pointer">{{ node.name }}</span>
                  <span v-else class="text-primary ma-3" :class="stat.open ? 'sm-bold' : 'sm-normal'" style="cursor: pointer">{{ node.name }}</span>
              </template>
            </Draggable>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions.js";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";
import { Draggable, OpenIcon } from '@he-tree/vue';
import '@he-tree/vue/style/default.css';
import '@he-tree/vue/style/material-design.css';

export default {
  props: ["page", "modal_name"],
  components: { Draggable, OpenIcon, BaseActionButton, BaseModal, BaseDraggableModal, PhFloppyDisk, PhX },
  data() {
    return {
      all_assets: [],
      assets: [],
      selected_assets: [],
      open_models: [],
      search: null,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal(this.modal_name);
      this.all_assets = await helpFunctions.getCustomRoute(this.$toast, "get-sorted-assets", true);
      this.showRecords();
    },
    clearSearch() {
      this.search = null;
      this.showRecords();
    },
    launchSearch() {
      if (this.search.length > 2) {
        this.showRecords();
      }
    },
    showRecords() {
      if (this.all_assets.length > 0) {
        this.assets = this.$lodash.cloneDeep(this.all_assets);
        if (this.search) {
          let response = helpFunctions.customSearch(this.assets, this.search);
          this.assets = response[0];
          this.open_models = response[2];
        }
        this.assets = helpFunctions.customSortingAndFiltering(this.assets);
        if (this.open_models.length > 0) {
          setTimeout(() => {
            this.expandFoundNodes(this.open_models);
            this.open_models = [];
          }, 1000);
        }
      }
    },
    expandFoundNodes(found_models) {
      found_models.forEach(found_model => {
        try {
          const stat = this.$refs.tree.getStat(found_model);
          if (stat) {
            this.$refs.tree.openNodeAndParents(stat);
          }
        } catch (error) {
          console.log(found_model);
        }
      });
    },
    save() {
      this.$emit('refresh', this.selected_assets);
      this.reset();
    },
    reset() {
      this.all_assets = [];
      this.assets = [];
      this.selected_assets = [];
      this.search = null;
      this.closeModal(this.modal_name);
    },
  },
};
</script>

<style scoped>
.v-checkbox {
  display: flex;
}
.he-tree__open-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.v-text-field >>> input {
  font-size: 12px !important;
}
.v-text-field >>> label {
  font-size: 12px !important;
}
</style>